// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
// import { Provider } from "react-redux";
// import { HelmetProvider } from "react-helmet-async";
// import { store } from "./redux/store";
// import SEO from "./components/SEO";

// import PricingCalculator from "./components/PricingCalculator";
// import Login from "./pages/Login";
// import Register from "./pages/Register"; // <-- NEW: Imported Register Page
// import Dashboard from "./pages/Dashboard";
// import Admin from "./pages/Admin";

// const Home = () => (
//   <div className="flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
//     <SEO title="Home" />
//     <div className="mb-8 p-4 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 font-semibold tracking-wider uppercase text-sm">
//       Post-Quantum Secure Tunnel
//     </div>
//     <h1 className="text-6xl font-extrabold text-white mb-6 tracking-tight">
//       Secure Your Workforce <br />
//       <span className="text-transparent bg-clip-text bg-gradient-to-r from-qrypt-primary to-qrypt-accent">
//         With Quantum Speed.
//       </span>
//     </h1>
//     <p className="text-xl text-gray-400 max-w-2xl mb-10 leading-relaxed">
//       QryptShield isn't just a VPN. It's a military-grade, post-quantum
//       encrypted tunnel designed for remote teams, universities, and enterprises.
//     </p>
//     <div className="flex flex-col sm:flex-row gap-4">
//       <Link
//         to="/pricing"
//         className="px-8 py-4 bg-qrypt-primary text-white rounded-xl font-bold text-lg hover:bg-blue-600 transition shadow-lg shadow-blue-500/20"
//       >
//         Get Protected Now
//       </Link>
//       <Link
//         to="/login"
//         className="px-8 py-4 bg-gray-800 text-white rounded-xl font-bold text-lg hover:bg-gray-700 transition border border-gray-700"
//       >
//         Member Login
//       </Link>
//     </div>
//   </div>
// );

// function App() {
//   return (
//     <Provider store={store}>
//       <HelmetProvider>
//         <Router>
//           <div className="min-h-screen text-white bg-qrypt-dark font-sans selection:bg-qrypt-primary selection:text-white">
//             <nav className="border-b border-gray-800 bg-qrypt-dark/80 backdrop-blur-md sticky top-0 z-50">
//               <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
//                 <Link
//                   to="/"
//                   className="text-2xl font-normal text-white flex items-center gap-2 hover:text-qrypt-primary transition"
//                 >
//                   <div class="flex items-center">
//                     <img
//                       src="logo.png"
//                       alt="logo"
//                       class="h-10 sm:h-12 md:h-12 w-auto object-contain"
//                     />
//                   </div>
//                   QryptShield
//                 </Link>
//                 <div className="hidden md:flex items-center space-x-8">
//                   <Link
//                     to="/"
//                     className="text-gray-300 hover:text-white transition font-medium px-3 py-2 rounded-lg"
//                   >
//                     Home
//                   </Link>
//                   <Link
//                     to="/pricing"
//                     className="text-gray-300 hover:text-white transition font-medium px-3 py-2 rounded-lg"
//                   >
//                     Pricing
//                   </Link>
//                   <Link
//                     to="/login"
//                     className="text-gray-300 hover:text-white transition font-medium px-3 py-2 rounded-lg"
//                   >
//                     Login
//                   </Link>
//                   {/* NEW: Added Sign Up button to NavBar */}
//                   <Link
//                     to="/register"
//                     className="px-5 py-2 bg-qrypt-primary/10 text-qrypt-primary border border-qrypt-primary/50 rounded-lg hover:bg-qrypt-primary hover:text-white transition font-bold"
//                   >
//                     Sign Up
//                   </Link>
//                 </div>
//               </div>
//             </nav>
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//               <Routes>
//                 <Route path="/" element={<Home />} />
//                 <Route path="/pricing" element={<PricingCalculator />} />
//                 <Route path="/login" element={<Login />} />
//                 <Route path="/register" element={<Register />} />{" "}
//                 {/* <-- NEW: Added Register Route */}
//                 <Route path="/dashboard" element={<Dashboard />} />
//                 <Route path="/admin" element={<Admin />} />
//               </Routes>
//             </div>
//           </div>
//         </Router>
//       </HelmetProvider>
//     </Provider>
//   );
// }
// export default App;

// change code 25/02/2026
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
  Navigate,
} from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { store } from "./redux/store";
import SEO from "./components/SEO";
import {
  Menu,
  X,
  Shield,
  Zap,
  Lock,
  ChevronRight,
  Activity,
  Server,
  Cpu,
  Twitter,
  Linkedin,
} from "lucide-react";

import PricingCalculator from "./components/PricingCalculator";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Security from "./pages/Security";
import About from "./pages/About";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const ProtectedRoute = ({ children, roles }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  // No token → login
  if (!token) return <Navigate to="/login" replace />;

  // Token present but role missing or not allowed → force re-auth
  if (roles && roles.length && (!role || !roles.includes(role))) {
    localStorage.clear();
    return <Navigate to="/login" replace />;
  }

  return children;
};

const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#0B0F19] text-white text-center px-6">
    <div>
      <p className="text-sm text-blue-300 font-semibold mb-2">404</p>
      <h1 className="text-3xl font-bold mb-3">Page not found</h1>
      <p className="text-gray-400 mb-6 max-w-md">
        The page you are looking for does not exist. Use the navigation above to
        continue.
      </p>
      <Link
        to="/"
        className="px-5 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-500 font-semibold"
      >
        Go Home
      </Link>
    </div>
  </div>
);

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [sessionEmail, setSessionEmail] = useState(
    () => localStorage.getItem("userEmail") || "",
  );

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    const handleStorage = () =>
      setSessionEmail(localStorage.getItem("userEmail") || "");

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "py-4" : "py-6"}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div
          className={`relative flex items-center justify-between px-6 py-3 rounded-2xl transition-all duration-300 ${
            scrolled
              ? "bg-[#0B0F19]/80 backdrop-blur-xl border border-white/10 shadow-2xl shadow-black/50"
              : "bg-transparent border border-transparent"
          }`}
        >
          <Link to="/" className="flex items-center gap-2 group">
            <div className="relative flex items-center justify-center w-8 h-8">
              <img
                src="logo.png"
                alt="logo"
                className="h-8 sm:h-9 md:h-10 w-auto object-contain"
              />
            </div>
            <span className="text-xl font-bold text-white tracking-tight">
              QryptShield VPN
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {["Home", "Pricing", "Contact"].map((item) => (
              <Link
                key={item}
                to={item === "Home" ? "/" : `/${item.toLowerCase()}`}
                className="text-sm font-medium text-gray-400 hover:text-white transition-colors underline-offset-2 underline"
              >
                {item}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            {sessionEmail ? (
              <>
                <span className="text-xs text-gray-300 px-3 py-1 rounded-full bg-white/5 border border-white/10">
                  Logged in as {sessionEmail}
                </span>
                <Link
                  to="/dashboard"
                  className="px-4 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-500 rounded-lg shadow-lg shadow-blue-500/20 transition-all hover:scale-105"
                >
                  Go to Dashboard
                </Link>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-sm font-medium text-gray-300 hover:text-white transition"
                >
                  Log in
                </Link>
                <Link
                  to="/register"
                  className="px-4 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-500 rounded-lg shadow-lg shadow-blue-500/20 transition-all hover:scale-105"
                >
                  Get Started
                </Link>
              </>
            )}
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-300"
            aria-label="Toggle menu"
          >
            {isOpen ? <X /> : <Menu />}
          </button>
        </div>

        {isOpen && (
          <div className="absolute top-full left-4 right-4 mt-2 p-4 bg-[#0B0F19] border border-white/10 rounded-2xl shadow-2xl flex flex-col gap-4 md:hidden animate-in slide-in-from-top-2">
            <Link
              to="/"
              onClick={() => setIsOpen(false)}
              className="text-gray-300 hover:text-white p-2"
            >
              Home
            </Link>
            <Link
              to="/pricing"
              onClick={() => setIsOpen(false)}
              className="text-gray-300 hover:text-white p-2"
            >
              Pricing
            </Link>
            {sessionEmail ? (
              <>
                <div className="text-gray-300 p-2">
                  Logged in as {sessionEmail}
                </div>
                <Link
                  to="/dashboard"
                  onClick={() => setIsOpen(false)}
                  className="bg-blue-600 text-white text-center py-3 rounded-lg font-semibold"
                >
                  Go to Dashboard
                </Link>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  onClick={() => setIsOpen(false)}
                  className="text-gray-300 hover:text-white p-2"
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  onClick={() => setIsOpen(false)}
                  className="bg-blue-600 text-white text-center py-3 rounded-lg font-semibold"
                >
                  Sign Up
                </Link>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

const FeatureCard = ({ icon: Icon, title, desc }) => (
  <div className="group relative p-6 rounded-2xl bg-white/[0.02] border border-white/[0.05] hover:bg-white/[0.04] hover:border-white/10 transition-all duration-300">
    <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 rounded-2xl transition-opacity" />
    <div className="relative z-10">
      <div className="w-12 h-12 rounded-lg bg-blue-500/10 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
        <Icon className="w-6 h-6 text-blue-400" />
      </div>
      <h3 className="text-lg font-semibold text-white mb-2">{title}</h3>
      <p className="text-sm text-gray-400 leading-relaxed">{desc}</p>
    </div>
  </div>
);

const Home = () => (
  <div className="relative">
    <SEO title="Home" />

    <div className="relative pt-40 pb-20 lg:pt-52 lg:pb-32 overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] bg-blue-600/20 rounded-[100%] blur-[100px] -z-10 opacity-50 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 text-center z-10">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-300 text-xs font-medium mb-8 backdrop-blur-md">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500" />
          </span>
          Post-Quantum Cryptography Ready
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-gray-600 via-white to-gray-900 tracking-tight mb-6 leading-[1.1]">
          Secure Your Future <br />
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 via-white to-orange-600">
            Before It's Decrypted.
          </span>
        </h1>

        <p className="text-lg text-gray-400 max-w-2xl mx-auto mb-10 leading-relaxed">
          QryptShield VPN provides military-grade, post-quantum encrypted
          tunnels for enterprises. Protect your data from the threats of
          tomorrow, today.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/register"
            className="w-full sm:w-auto px-8 py-4 bg-white text-black rounded-xl font-bold hover:bg-gray-100 transition shadow-[0_0_20px_rgba(255,255,255,0.3)] flex items-center justify-center gap-2"
          >
            Start Free Trial <ChevronRight size={18} />
          </Link>
          <Link
            to="/pricing"
            className="w-full sm:w-auto px-8 py-4 bg-white/5 text-white border border-white/10 rounded-xl font-bold hover:bg-white/10 transition backdrop-blur-md"
          >
            View Pricing
          </Link>
        </div>
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-4 pb-32">
      <div className="grid md:grid-cols-3 gap-6">
        <FeatureCard
          icon={Lock}
          title="Hybrid Post-Quantum Encryption"
          desc="Dual-layer security combining classical ECDH with NIST standardized PQC algorithms (Kyber/Dilithium)."
        />
        <FeatureCard
          icon={Zap}
          title="High-Speed PQTLS Tunnel"
          desc="Quantum resistance with minimal latency overhead and enterprise-grade throughput."
        />
        <FeatureCard
          icon={Shield}
          title="Zero-Trust Architecture"
          desc="Every connection request is authenticated before a quantum tunnel is established."
        />
        <FeatureCard
          icon={Activity}
          title="Quantum Vulnerability Scanning"
          desc="Detects weak legacy cryptography and flags compliance risks in real time."
        />
        <FeatureCard
          icon={Server}
          title="Seamless Deployment"
          desc="Drop-in compatibility with existing OpenVPN & WireGuard infrastructure."
        />
        <FeatureCard
          icon={Cpu}
          title="Crypto-Agility & Compliance"
          desc="Built for GDPR, HIPAA, and SOC 2 with crypto-agile algorithm hot-swaps."
        />
      </div>
    </div>

    <footer className="mt-20 border-t border-white/5 bg-[#0B0F19]/50 backdrop-blur-lg pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 mb-16">
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 group mb-4">
              <div className="relative flex items-center justify-center w-8 h-8">
                <img
                  src="logo.png"
                  alt="logo"
                  className="h-8 sm:h-9 md:h-10 w-auto object-contain"
                />
              </div>
              <span className="text-xl font-bold text-white tracking-tight">
                QryptShield VPN
              </span>
            </Link>
            <p className="text-sm text-gray-400 leading-relaxed mb-6 pe-4">
              Military-grade, post-quantum encrypted tunnels for the modern
              enterprise.
            </p>
            <div className="flex gap-4">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-white/5 text-gray-400 hover:text-white hover:bg-white/10 transition-all duration-300"
              >
                <Twitter size={18} />
              </a>
              <a
                href="https://www.linkedin.com/company/qryptshield-technologies-pvt-ltd"
                className="p-2 rounded-lg bg-white/5 text-gray-400 hover:text-white hover:bg-white/10 transition-all duration-300"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-6">Product</h4>
            <ul className="space-y-4 text-sm text-gray-400">
              <li>
                <Link
                  to="/pricing"
                  className="hover:text-blue-400 hover:translate-x-1 inline-block transition-transform duration-300"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/download"
                  className="hover:text-blue-400 hover:translate-x-1 inline-block transition-transform duration-300"
                >
                  Download
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-6">Resources</h4>
            <ul className="space-y-4 text-sm text-gray-400">
              <li>
                <Link
                  to="/docs"
                  className="hover:text-blue-400 hover:translate-x-1 inline-block transition-transform duration-300"
                >
                  Documentation
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="hover:text-blue-400 hover:translate-x-1 inline-block transition-transform duration-300"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/community"
                  className="hover:text-blue-400 hover:translate-x-1 inline-block transition-transform duration-300"
                >
                  Community
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-6">Company</h4>
            <ul className="space-y-4 text-sm text-gray-400">
              <li>
                <Link
                  to="/about"
                  className="hover:text-blue-400 hover:translate-x-1 inline-block transition-transform duration-300"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="hover:text-blue-400 hover:translate-x-1 inline-block transition-transform duration-300"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} QryptShield. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500">
            <Link
              to="/privacy"
              className="hover:text-white transition-colors duration-300"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="hover:text-white transition-colors duration-300"
            >
              Terms of Service
            </Link>
            <Link
              to="/security"
              className="hover:text-white transition-colors duration-300"
            >
              Security
            </Link>
          </div>
        </div>
      </div>
    </footer>
  </div>
);

const AppShell = () => {
  const location = useLocation();
  const hideNavbar =
    location.pathname.startsWith("/dashboard") ||
    location.pathname.startsWith("/admin");

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-[#0B0F19] text-white selection:bg-blue-500 selection:text-white font-sans">
        {!hideNavbar && (
          <div className="fixed inset-0 z-0 pointer-events-none">
            <div
              className="absolute inset-0 opacity-[0.1]"
              style={{
                backgroundImage: `linear-gradient(to right, #ffffff60 1px, transparent 1px), linear-gradient(to bottom, #ffffff60 1px, transparent 1px)`,
                backgroundSize: "40px 40px",
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F19] via-transparent to-transparent" />
          </div>
        )}

        {!hideNavbar && <Navbar />}

        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<PricingCalculator />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/security" element={<Security />} />
            <Route path="/about" element={<About />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>
    </>
  );
};

function App() {
  return (
    <Provider store={store}>
      <HelmetProvider>
        <Router>
          <AppShell />
        </Router>
      </HelmetProvider>
    </Provider>
  );
}

export default App;
